'use strict'

export default function templateSignupFields(fields) {
  let html = ''
  fields.forEach((f) => {
    html += `<input type='hidden' name='${f.name}' value=${f.value}>`
  })
  return html
}